import { Dispatch, SetStateAction } from 'react'

import { CPBaseForm } from '../../../CountryProgramme/typesCPCreate'
import SectionCCreate from '../Create/Create'
import { SectionCEditProps } from './types'

function SectionCEdit(props: SectionCEditProps) {
  const { Comments, form, setForm, showComments, ...rest } = props
  return (
    <>
      <SectionCCreate
        form={form as unknown as CPBaseForm}
        setForm={setForm as unknown as Dispatch<SetStateAction<CPBaseForm>>}
        {...rest}
      />
      {showComments ? (
        <Comments form={form} section="section_c" setForm={setForm} />
      ) : null}
    </>
  )
}

export default SectionCEdit
